import { setInstanceByEnvType } from "src/utils/helpers/requestApi/isServer";

interface GetMainProductInfoParams {
  product_slug: string;
  city_slug: string;
}

export interface MainProductInfoSchema {
  name: string;
  value: string;
  variants: ProductInfoVariants[];
}

interface ProductInfoVariants {
  name: string;
  is_active: boolean;
  slug: string;
}

export const getMainProductInfo = (params: GetMainProductInfoParams) =>
  setInstanceByEnvType().get<MainProductInfoSchema[]>(
    "/v2/catalog/product_page/info",
    {
      params,
    }
  );
